import {Action} from '@ngrx/store';

/**
 * All actions of the user-settings sub-store are described here
 * An action can have an optional payload
 */
export const UPDATE_USER_SETTINGS = '[USER] UPDATE_USER_SETTINGS';
export const UPDATED_USER_SETTINGS = '[USER] UPDATED_USER_SETTINGS';

export class UpdateUserSettingsAction implements Action {
  readonly type = UPDATE_USER_SETTINGS;

  constructor(public userId: number) {
  }
}

export class UpdatedUserSettingsAction implements Action {
  readonly type = UPDATED_USER_SETTINGS;

  constructor(public payload: GlobalUserSettingDto[]) {
  }
}

export type UserSettingsAction = UpdateUserSettingsAction | UpdatedUserSettingsAction;
